import React from "react";
import { BarContainer, BarTrack, BarFill, BarLabel } from "./SparkBar.styled";

/**
 * Animated progress bar with percentage label.
 *
 * @param {number} value  — current value
 * @param {number} max    — maximum value (100%)
 * @param {string} color  — bar fill color
 */
const SparkBar = ({ value, max, color }) => {
  const pct = max > 0 ? Math.min((value / max) * 100, 100) : 0;
  return (
    <BarContainer>
      <BarTrack>
        <BarFill $pct={pct} $color={color} />
      </BarTrack>
      <BarLabel>{pct.toFixed(0)}%</BarLabel>
    </BarContainer>
  );
};

export default SparkBar;
